// import Vue from "vue";
import App from "./App.vue";
import "./plugins/vant.js";
import store from "./store";
import mixin from "@/mixin";
import z from "@/components/z";
import {setFileServer} from "@/mixin/mixin_common";
import axiosInstance, {get, post} from "@/utils/request";
import "./plugins/element.js";
import {isConnected} from "@/utils/socket/websocketUtil";
import "@/utils";
import {listToMapGroupBy} from './utils/collUtil'
import i18n from "@/lang/i18n";

Vue.use(mixin);
Vue.use(z);

Vue.config.productionTip = process.env.NODE_ENV !== 'production';
import "@/common/style/index.scss";
import "@/common/style/element-ui.scss";
import "@/common/style/vant-ui.scss";

import ParentJs from '@/parent-ui/src/main/js/index'
import ParentVant from '@/parent-ui/src/main/ui-vant/index'
import ParentH5 from '@/parent-ui/src/main/ui-h5/index'
import '@/parent-ui/src/main/business/user/index.scss'
import '@/parent-ui/src/main/ui-h5/svgicon/index'


async function initUser() {
    let isLogin = await store.dispatch("user/checkLogin");
    if (isLogin) {
        await store.dispatch("user/getUserInfo")
        await store.dispatch("user/getChatUnread")
        await store.dispatch("user/getUserMoney");
        await store.dispatch("user/getUserLevel");
        await store.dispatch("user/getUserCart");
        await store.dispatch("user/getWishList");
        await store.dispatch("user/getCompareList");
        await store.dispatch("user/initSocket");
        store.dispatch('user/getNoticeList')
        store.dispatch('user/getUserNoticeNum')
    } else {
        await store.dispatch("user/logoutFront");
    }
}

initUser();

import router from "./router";

// let country_list = []
// let messages
// 自定义翻译Map<String, String>
// let transList = []


// export let i18n
// import VueI18n from 'vue-i18n'
// Vue.use(VueI18n)
// ELEMENT.locale((key, value) => i18n.t(key, value)) //方便element使用，其内部封装也是采用的i18n
import {Locals} from './lang'

const lang_map = {
    'hi': 'india',
    'ms': 'bm',
    'ar': 'ar-IQ',
    'tr': 'tr-TR',
    'ko': 'kr',
    'no': 'nb-NO', // 挪威
    'nl': 'nl-NL', // 荷兰
    'zh-cn': 'zh-CN',
    'zh-hk': 'zh-HK',
    'zh-tw': 'zh-HK',
}

store.dispatch('common/getCountryList').then(async countryList => {
    // messages = require('./lang/index.js').default
    // country_list = list
    // 看国家列表有没有新的key
    // country_list.forEach(o => {
    //   if (!messages[o.langCode]) {
    //     messages[o.langCode] = o.langKey ? messages[o.langKey] : messages['en-US']
    //   }
    // })
    let country = store.getters.country || countryList.length && countryList[0];
    let lang = country.langCode;
    await i18n.changeLanguage(lang || 'en-US');

    await store.dispatch('common/setCountry', country)
    await store.dispatch("common/setLang", lang);

    // // 计价单位
    // let unit = localStorage.getItem('unit') || 'USD'
    // store.dispatch('common/setUnitCountry', countryList.filter(o => o.currencyCode === unit)[0])

    // transList = await store.dispatch('common/getTranslationList')

    store.dispatch("common/getDictMapAll").then(allMap => {
        let fileServer = allMap["FILE_UPLOAD_DOMAIN"];
        setFileServer(fileServer)
        // 初始化公共工具类信息
        ParentJs.install(
            Vue,
            axiosInstance,
            fileServer,
            i18n
        )
        Vue.use(ParentVant)
        Vue.use(ParentH5)
        // 设置favicon
        const faviconUrl = allMap['SITE_FAVICON']
        changeFavicon(faviconUrl && faviconUrl.replace(/{host}/g, allMap['FILE_UPLOAD_DOMAIN']))


        // setLocalLang()

        new Vue({
            i18n,
            router,
            store,
            render: h => h(App)
        }).$mount("#app");
    });

})

function changeFavicon(faviconUrl) {
    if (!faviconUrl) return
    let favicon = document.querySelector('link[rel="icon"]')
    if (favicon !== null) {
        favicon.href = faviconUrl
    } else {
        favicon = document.createElement('link')
        favicon.rel = 'icon'
        favicon.href = faviconUrl
        document.head.appendChild(favicon)
    }
}

// function setLocalLang() {
//   // 缓存 -> 浏览器语言 -> 默认第一个国家语言
//   let langCode = localStorage.getItem('langCode') || localStorage.getItem('lang')
//
//   let filter_country = country_list.filter(o => o.langCode === langCode)
//   let country = filter_country.length > 0 ? filter_country[0] : country_list[0]
//   let lang = country.langKey || country.langCode
//   // debugger
//   if (!lang) {
//     let language = (navigator.language || navigator.browserLanguage).toLowerCase()
//     lang = lang_map[language] || lang_map[language.split('-')[0]]
//   }
//   store.dispatch('common/setCountry', country)
//   Locals(lang)
//   // 自定义翻译
//   let langMap = listToMapGroupBy(transList, 'lang')
//   for (let lang in langMap) {
//     let langObj = messages[lang]
//     let list = langMap[lang].map(item => {
//       return { [item.code]: item.content }
//     })
//     try {
//       messages[lang] && (messages[lang] = Object.assign(langObj, ...list))
//     } catch (e) {
//       console.error(e)
//     }
//   }
//
//   // // en 赋值给 en-US en-PH等语言
//   // for (let langCode of Object.keys(messages)) {
//   //   let langCodeSplits = langCode.split("-");
//   //   if (langCodeSplits.length === 2 && !(messages[langCode] && Object.keys(messages[langCode]).length)) {
//   //     messages[langCode] = messages[langCodeSplits[0]]
//   //   }
//   // }
//
//   // vue上挂在vant i18n方法
//   i18n = new VueI18n({
//     locale: lang,
//     messages,
//     silentTranslationWarn: true,
//     fzrallbackLocale: 'en-US',
//   })
// }


Vue.prototype.$get = get;
Vue.prototype.$post = post;

let initTime = 0

let listenerReloadWebsocket = function () {
    let connectedFlag = isConnected();
    let now = new Date().getTime();
    let betweenSeconds = (now - initTime) / 1000;
    console.error("浏览器进入后台,连接中: " + connectedFlag + ' '+betweenSeconds+'s', arguments);
    if (!connectedFlag && betweenSeconds >= 3) {
        initTime = now
        // 唤醒且未连接
        console.warn("浏览器进入后台,重连websocket");
        initUser();
    }
};
document.addEventListener("visibilitychange", listenerReloadWebsocket);
document.addEventListener("pageshow", listenerReloadWebsocket);

